import {noop} from "lodash-es"
import {Overlay} from "ol"
import {FeatureLike} from "ol/Feature"
import mapService from "@ui/services/MapService"
import FeatureService from "./FeatureService"
import {getIconPath, Icons, SelectedIcons} from "./styles"

export interface IPopupService {
  init(
    popupTarget?: HTMLDivElement,
    showPopupCallback?: (feature: FeatureLike) => void,
    hidePopupCallback?: () => void
  ): void
  showPopup(feature: FeatureLike, text: string, onHide?: ()=>void): void
  hidePopup(): void
  getPopupFeature(): FeatureLike | undefined
}

export class PopupService implements IPopupService {
  #popup?: Overlay
  #onHide: () => void = noop
  #showPopupCallback: (feature: FeatureLike) => void = noop
  #hidePopupCallback: () => void = noop

  init(popupTarget?: HTMLDivElement,
       showPopupCallback: (feature: FeatureLike) => void = noop,
       hidePopupCallback: () => void = noop
  ) {
    this.#popup = new Overlay({
			element: popupTarget,
			// autoPan: {animation: {duration: 250}},
		})
    const buttons = this.#popup.getElement()?.getElementsByTagName("button")
		if (buttons?.length) {
			// последняя кнопка должна быть Close
			buttons.item(buttons.length - 1)?.addEventListener("click", this.hidePopup.bind(this))
		}
    this.#showPopupCallback = showPopupCallback
    this.#hidePopupCallback = hidePopupCallback
    mapService.addOverlay(this.#popup)
  }

  showPopup(feature: FeatureLike, text: string, onHide: () => void = noop) {
    if (this.#popup?.get("target")) {
      this.hidePopup()
    }
		this.#popup?.set("target", feature)

		const contentWrapper = this.#popup?.getElement()?.getElementsByClassName("popup-content")?.item(0)
		while (contentWrapper?.firstChild) {
			contentWrapper?.removeChild(contentWrapper?.firstChild)
		}
    const content = document.createElement("div")
    contentWrapper?.appendChild(content)
    content.insertAdjacentHTML("beforebegin", text)

    this.#popup?.setPosition(FeatureService.getFeatureCoordinates(feature))
    this.#onHide = onHide

    if (this.#popup?.getElement()?.scrollHeight) {
      this.#popup?.getElement()?.style.setProperty("--height", `${this.#popup?.getElement()?.scrollHeight}px`)
      this.#popup?.getElement()?.style.setProperty("--width", `${this.#popup?.getElement()?.scrollWidth}px`)

      const props = feature.getProperties()
      const iconPath = getIconPath(feature, props.layerId)
      if (iconPath && (SelectedIcons[iconPath] || Icons[iconPath])) {
        const svg = (new DOMParser().parseFromString(SelectedIcons[iconPath] || Icons[iconPath], "image/svg+xml")).documentElement
        this.#popup?.getElement()?.style.setProperty("--icon-height", `${svg.getAttribute("height")}px`)
        this.#popup?.getElement()?.style.setProperty("--icon-width", `${svg.getAttribute("width")}px`)
      }
    }
    this.#showPopupCallback(feature)
	}

  hidePopup() {
		this.#popup?.setPosition(undefined)
		this.#popup?.set("target", undefined)
    this.#onHide()
    this.#onHide = noop
    this.#hidePopupCallback()
	}

  getPopupFeature(): FeatureLike | undefined {
		return this.#popup?.get("target")
	}
}

export default new PopupService() as IPopupService
